import { bool, color, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { QRCodeErrorLevel, QRCodeSize } from './qrcode-constants.js';
const QRCodeProperties = {
    backgroundColor: {
        defaultValue: '#FFFFFF',
        type: color,
    },
    errorLevel: {
        defaultValue: QRCodeErrorLevel.LOW,
        type: oneOf(enumValues(QRCodeErrorLevel)),
    },
    foregroundColor: {
        defaultValue: '#000000',
        type: color,
    },
    includeMargin: {
        defaultValue: false,
        type: bool,
    },
    size: {
        defaultValue: QRCodeSize.SMALL,
        type: oneOf(enumValues(QRCodeSize)),
    },
    value: {
        defaultValue: 'Oswald',
        type: string,
    },
};
export { QRCodeProperties, };
//# sourceMappingURL=qrcode-types.js.map